$(document).ready(function () {
  // Initialize Slick
  $(".cstm-four-videos-slider").slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    infinite: true,
    autoplay: false,
    prevArrow:
      '<button type="button" class="slick-prev"></button>',
    nextArrow:
      '<button type="button" class="slick-next"></button>',
    responsive: [
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 2,
          dots: true, 
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          dots: true, 
        },
      },
    ],
  });

  // Ensure videos autoplay correctly
  document.querySelectorAll(".cstm-video").forEach((v) => {
    v.play().catch(() => {
      v.muted = true;
      v.play();
    });
  });
});
